/* =============================================================
   SENBIRD TEA - Blog Styling Scripts
   Version 1.1 | February 18, 2026

   Companion to senbird-blog-styles.css
   Handles two things CSS alone cannot:
   1. Overrides Shopify's CSS variable on heading font sizes
   2. Converts "Related Articles" sections into styled
      Related Reading blocks

   Add this JS to your Shopify theme:
   Shopify Admin > Online Store > Themes > Edit Code >
   Assets > Create new file (senbird-blog-scripts.js)

   Then reference it in theme.liquid (before </body>):
   <script src="{{ 'senbird-blog-scripts.js' | asset_url }}" defer></script>
   ============================================================= */

(function() {
  'use strict';

  // Only run on blog article pages
  if (!document.body.classList.contains('template-article')) return;

  function applyBlogStyles() {
    var content = document.querySelector('.custom_content_sty') ||
                  document.querySelector('.article-template__content');
    if (!content) return;

    // ---------------------------------------------------------
    // 1. HEADING OVERRIDES
    //    Shopify's base.css uses calc(var(--font-heading-scale) * Xrem)
    //    which overrides even !important in stylesheets.
    //    We apply inline styles with !important via setAttribute
    //    to guarantee our sizes win.
    // ---------------------------------------------------------

    var headingStyles = {
      h1: 'font-family:"Roboto Condensed",sans-serif !important;font-weight:700 !important;font-size:56px !important;text-transform:uppercase !important;color:#323230 !important;line-height:1.15 !important;margin-bottom:16px !important;',
      h2: 'font-family:"Roboto Condensed",sans-serif !important;font-weight:700 !important;font-size:40px !important;text-transform:uppercase !important;color:#323230 !important;line-height:1.2 !important;margin-top:40px !important;margin-bottom:16px !important;',
      h3: 'font-family:"Roboto Condensed",sans-serif !important;font-weight:600 !important;font-size:26px !important;text-transform:uppercase !important;color:#323230 !important;line-height:1.3 !important;margin-top:32px !important;margin-bottom:12px !important;',
      h4: 'font-family:"Roboto Condensed",sans-serif !important;font-weight:500 !important;font-size:20px !important;text-transform:uppercase !important;color:#323230 !important;line-height:1.3 !important;margin-top:28px !important;margin-bottom:10px !important;',
      h5: 'font-family:"Noto Sans",sans-serif !important;font-weight:700 !important;font-size:18px !important;text-transform:none !important;color:#323230 !important;line-height:1.4 !important;margin-top:24px !important;margin-bottom:8px !important;'
    };

    // Apply to each heading level
    Object.keys(headingStyles).forEach(function(tag) {
      var headings = content.querySelectorAll(tag);
      headings.forEach(function(el) {
        // Skip headings inside the Related Reading block (handled separately)
        if (el.closest('.related-reading-block')) return;
        el.setAttribute('style', headingStyles[tag]);
      });
    });

    // ---------------------------------------------------------
    // 2. RESPONSIVE HEADING SIZES
    //    Adjust heading sizes for mobile screens
    // ---------------------------------------------------------

    if (window.innerWidth <= 768) {
      var mobileOverrides = {
        h1: 'font-size:36px !important;',
        h2: 'font-size:28px !important;',
        h3: 'font-size:22px !important;',
        h4: 'font-size:18px !important;'
      };

      Object.keys(mobileOverrides).forEach(function(tag) {
        content.querySelectorAll(tag).forEach(function(el) {
          if (el.closest('.related-reading-block')) return;
          var currentStyle = el.getAttribute('style') || '';
          currentStyle = currentStyle.replace(/font-size:[^;]+!important;/, mobileOverrides[tag]);
          el.setAttribute('style', currentStyle);
        });
      });
    }

    // ---------------------------------------------------------
    // 3. RELATED READING BLOCK CONVERSION
    // ---------------------------------------------------------

        var allHeadings = content.querySelectorAll('h3');
    var relatedH2 = null;

    allHeadings.forEach(function(heading) {
      var text = heading.textContent.toLowerCase().trim();
            if ((text.indexOf('related') !== -1 &&
                      (text.indexOf('article') !== -1 || text.indexOf('reading') !== -1)) ||
                text === 'explore more about japanese tea') {
        relatedH2 = heading;
      }
    });

    if (relatedH2) {
      var nextEl = relatedH2.nextElementSibling;
      var relatedUL = null;
      while (nextEl) {
        if (nextEl.tagName === 'UL') {
          relatedUL = nextEl;
          break;
        }
        if (nextEl.tagName !== 'P' && nextEl.tagName !== 'BR') break;
        nextEl = nextEl.nextElementSibling;
      }

      if (relatedUL) {
        var block = document.createElement('div');
        block.className = 'related-reading-block';
                var heading = document.createElement('h3');
                heading.textContent = 'EXPLORE MORE ABOUT JAPANESE TEA';
        heading.setAttribute('style',
          'margin-top:0 !important;' +
          'color:#516E36 !important;' +
          'font-family:"Roboto Condensed",sans-serif !important;' +
          'font-size:26px !important;' +
          'font-weight:600 !important;' +
          'text-transform:uppercase !important;' +
          'margin-bottom:12px !important;' +
          'line-height:1.3 !important;'
        );

        block.appendChild(heading);

        var clonedUL = relatedUL.cloneNode(true);
        clonedUL.querySelectorAll('li').forEach(function(li) {
          li.style.cssText = "font-family:'Noto Sans',sans-serif;font-size:16px;line-height:1.7;color:#323230;";
        });
        clonedUL.querySelectorAll('a').forEach(function(a) {
          a.style.fontFamily = "'Noto Sans', sans-serif";
        });

        block.appendChild(clonedUL);

        relatedH2.parentNode.insertBefore(block, relatedH2);
        relatedH2.remove();
        relatedUL.remove();
      }
    }

    // ---------------------------------------------------------
    // 4. VIDEO EMBED SPACING (FALLBACK)
    // ---------------------------------------------------------

    var iframes = content.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]');
    iframes.forEach(function(iframe) {
      var wrapper = iframe.parentElement;
      if (wrapper && wrapper.tagName === 'DIV') {
        wrapper.style.marginTop = '32px';
        wrapper.style.marginBottom = '32px';

        var nextSibling = wrapper.nextElementSibling;
        if (nextSibling && (nextSibling.tagName === 'H2' || nextSibling.tagName === 'H3')) {
          var currentMT = nextSibling.getAttribute('style') || '';
          currentMT = currentMT.replace(/margin-top:[^;]+!important;/, 'margin-top:16px !important;');
          nextSibling.setAttribute('style', currentMT);
        }
      }
    })
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyBlogStyles);
  } else {
    applyBlogStyles();
  }

})()